import { jsx as _jsx } from "react/jsx-runtime";
import SearcherActivitiesSkeleton from "../../../searcher-activities/components/skeleton/index.js";
import SearcherCruSkeleton from "../../../searcher-cru/components/skeleton/index.js";
import SearcherFerSkeleton from "../../../searcher-fer/components/skeleton/index.js";
import SearcherFerryHotelSkeleton from "../../../searcher-ferry-hotel/components/skeleton/index.js";
import SearcherFliSkeleton from "../../../searcher-fli/components/skeleton/index.js";
import SearcherFlightHotelSkeleton from "../../../searcher-flight-hotel/components/skeleton/index.js";
import SearcherLeiSkeleton from "../../../searcher-lei/components/skeleton/index.js";
import SearcherTrainHotelSkeleton from "../../../searcher-train-hotel/components/skeleton/index.js";
const SearcherIdToSearcherSkeleton = {
    FER_HOT: SearcherFerryHotelSkeleton,
    FER: SearcherFerSkeleton,
    FLI: SearcherFliSkeleton,
    FLI_HOT: SearcherFlightHotelSkeleton,
    TRA_HOT: SearcherTrainHotelSkeleton,
    ACTIVITIES: SearcherActivitiesSkeleton,
    LEI: SearcherLeiSkeleton,
    CRU: SearcherCruSkeleton
};
export const renderSearcherSkeleton = (searcherId, optionalProps)=>{
    const SkeletonComponent = SearcherIdToSearcherSkeleton[searcherId];
    if (!SkeletonComponent) return null;
    return /*#__PURE__*/ _jsx(SkeletonComponent, {
        ...optionalProps
    });
};

//# sourceMappingURL=utils.js.map